import React from "react";
import MDEditor from "@uiw/react-md-editor";
import {
  Controller,
  type Control,
  type FieldValues,
  type Path,
  type RegisterOptions,
  type UseFormRegister,
  type ControllerRenderProps,
} from "react-hook-form";
import styles from "./Markdown.module.scss";
import withLabelAndError from "../withLabelAndError";

const excludeCommands = [
  "quote",
  "edit",
  "preview",
  "code",
  "codeBlock",
  "fullscreen",
  "help",
  "comment",
  "checked-list",
];

interface MarkdownProps<T extends FieldValues = FieldValues> {
  control?: Control<T>;
  register?: UseFormRegister<T>;
  validations?: RegisterOptions<T, Path<T>>;
  name: Path<T>;
  placeholder?: string;
  [key: string]: any; // allow extra props
}

const Markdown = <T extends FieldValues = FieldValues>({
  control,
  register,
  name,
  validations,
  placeholder,
  ...rest
}: MarkdownProps<T>) => {
  const filterCommands = (command: any) => {
    return !excludeCommands.includes(command?.name) && command;
  };

  const renderMarkdown = (
    field: ControllerRenderProps<T, Path<T>> | any = {}
  ) => (
    <MDEditor
      {...field}
      {...rest}
      commandsFilter={filterCommands}
      value={field.value || ""}
      className={styles.inputField}
      onChange={(val: string | undefined) => field.onChange(val || "")}
      height={200}
    />
  );

  if (control) {
    return (
      <Controller
        control={control}
        // rules={validations}
         {...(validations ? { rules: validations } : {})}
        name={name}
        render={({ field }) => renderMarkdown(field)}
      />
    );
  } else if (register) {
    const field = register(name, validations);
    return renderMarkdown(field);
  } else {
    return renderMarkdown();
  }
};

const MarkdownWithLabelAndError = withLabelAndError(Markdown);

export default MarkdownWithLabelAndError;
export { Markdown };

